(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initCountdown(root) {
    var target = new Date(root.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) return;

    function set(key, value) {
      var el = root.querySelector('[data-cd="' + key + '"]');
      if (el) el.textContent = pad(value);
    }

    function tick() {
      var diff = Math.max(0, target - Date.now());
      set('d', Math.floor(diff / 86400000));
      set('h', Math.floor((diff % 86400000) / 3600000));
      set('m', Math.floor((diff % 3600000) / 60000));
      set('s', Math.floor((diff % 60000) / 1000));
    }

    tick();
    setInterval(tick, 1000);
  }

  function initFormGuard(form) {
    form.addEventListener('submit', function (e) {
      var pw = form.querySelector('.pv-field');
      if (pw && !pw.value.trim()) {
        e.preventDefault();
        pw.focus();
      }
    });
  }

  document.querySelectorAll('[data-countdown]').forEach(initCountdown);
  document.querySelectorAll('.pv-form').forEach(initFormGuard);
})();
